export default "__VITE_ASSET__38167b83__"